// LD-2448
// Global guard against key-repeat "spam" activation of buttons and links.
//
// When an activatable control (button, link, radio, checkbox…) has DOM focus,
// holding Enter/Space makes the browser fire `keydown` on every OS key-repeat,
// and each of those synthesizes a `click`. That lets a user trigger a single
// button dozens of times in a couple of seconds (e.g. confirm-alarm spam),
// with no JS handler ever getting a chance to debounce.
//
// Physical mouse clicking is bounded by human speed; key-repeat is the only way
// to generate that volume. We cancel the *repeat* activations at the source, in
// the capture phase, before any component handler or the default click runs.
//
// Scope is intentionally narrow so normal input is untouched: only the two
// activation keys, and only on activatable controls (never text fields, so
// held Backspace / arrows / typing / textarea newlines still work).

const ACTIVATABLE = 'button, [role="button"], a[href], summary, ' +
  'input[type="submit"], input[type="button"], input[type="radio"], input[type="checkbox"]'

const ACTIVATION_CODES = new Set(['Enter', 'NumpadEnter', 'Space'])

export function initInputGuard() {
  document.addEventListener('keydown', (event) => {
    if (!event.repeat || !ACTIVATION_CODES.has(event.code)) return

    const target = event.target
    if (target instanceof Element && target.closest(ACTIVATABLE)) {
      event.preventDefault()
    }
  }, { capture: true })
}
